import { createContext } from 'react';

const SearchBarContext = createContext();

export default SearchBarContext;
